import React from "react";
import { useSelector } from "react-redux";

import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const RiskMembers = ({ qa }) => {
  const { membersAtRiskNumber, membersAtRiskRawDataLink } = useSelector(
    (state) => state.membershipUnits.membershipUnits.membersAtRisk
  );

  const previousToggleValue = useSelector((state) => state.membershipUnits.previousToggleValue);

  if (previousToggleValue) return null;

  return (
    <>
      <div className="content__el">
        <DataDisplay
          label="At Risk Members"
          type="number"
          value={membersAtRiskNumber}
          url={membersAtRiskRawDataLink}
          disableAnimation={qa}
          toolTipId="atRiskMembersToolTipMTD"
        />
      </div>
    </>
  );
};

export default RiskMembers;
